import { Container } from "@mui/material";
import React, { Fragment } from "react";
import EduCard from "../../components/Cards/EduCard";
import Break from "../../components/Break";
import { schools } from "./helper";

const EducationFallback = (): JSX.Element =>
(
    <Container>
        {
            schools.map((edu, i) =>
                <Fragment key={i}>
                    <EduCard
                        image={edu.image}
                        school={edu.school}
                        degree={edu.degree}
                        gradDate={edu.gradDate}
                        link={edu.link}
                        courses={edu.courses}
                        schoolLink={edu.schoolLink} 
                        tools={edu.tools}/>
                    <Break />
                </Fragment>
            )
        }
    </Container>
)
export default EducationFallback